import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FoodService from "../../services/FoodService";
import Editor from "react-simple-wysiwyg";

const EditFoodDrink = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [html, setHtml] = useState("my <b>HTML</b>");
  function handleEditor(e) {
    setHtml(e.target.value);
  }

  const initialFoodDrinkState = {
    id: null,
    name: "",
    menucategory_id: "",
    description: "",
    price: "",
    published: false,
  };

  const initialMenucategoryState = {
    id: null,
    name: "",
  };
  const [currentFoodDrink, setCurrentFoodDrink] = useState(
    initialFoodDrinkState
  );
  const [menuCategory, setMenuCategory] = useState(initialMenucategoryState);
  const [images, setImages] = useState([]);
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState("alert alert-danger");
  const [submitted, setSubmitted] = useState(false);

  const getFoodDrink = (id) => {
    const getdt = {};
    FoodService.get(id)

      .then((response) => {
        const data = response.data;
        setCurrentFoodDrink(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getMenucategory = () => {
    FoodService.getAllcategories()
      .then((response) => {
        const newValue = [];
        const datas = response.data;
        // console.log(datas)
        // datas.forEach(data => {
        //   data['image']=JSON.parse(data['image'])

        //   newValue.push(data)
        // });
        setMenuCategory(datas);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id) getFoodDrink(id);
    getMenucategory();
  }, [id]);

  useEffect(() => {}, [currentFoodDrink]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentFoodDrink({ ...currentFoodDrink, [name]: value });
  };

  const updateFoodDrink = () => {
    FoodService.update(currentFoodDrink.id, currentFoodDrink)
      .then((response) => {
        setMessage("The FoodDrink was updated successfully!");
        setSubmitted(true);
        setAlert("alert alert-success");
        console.log(currentFoodDrink);
      })
      .catch((e) => {
        setMessage("Error: " + e.response.data.message);
        setSubmitted(true);
        console.log(e);
      });
  };

  const deleteFoodDrink = () => {
    FoodService.remove(currentFoodDrink.id)
      .then((response) => {
        console.log(response.data);
        navigate("/admin/food");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // console.log("Current FNB: "+JSON.stringify(currentFoodDrink))

  return (
    <div className="container pb-10">
      {currentFoodDrink ? (
        <>
          <h1 className="text-1xl lg:text-1xl font-semibold py-10">
            {" "}
            {currentFoodDrink.name}
          </h1>
          <div>
            {submitted ? (
              <div
                className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                role="alert"
              >
                <p style={{ marginBottom: "0" }}>{message}</p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: "0" }}>{message}</p>
              </>
            )}
            <br></br>
          </div>

          <form className="w-full">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Name
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="name"
                  name="name"
                  type="text"
                  value={currentFoodDrink.name}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-password"
                >
                  Description
                </label>
              </div>
              <div className="md:w-2/3">
                {/* <textarea
                  rows="5"
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="description"
                  name="description"
                  type="text"
                  value={currentFoodDrink.description}
                  required
                  onChange={handleInputChange}
                >
                  <Editor
                    value={html}
                    onChange={handleEditor}
                  />
                </textarea> */}

                <Editor
                  rows="5"
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="description"
                  name="description"
                  type="text"
                  value={currentFoodDrink.description}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-password"
                >
                  Item Category
                </label>
              </div>
              <div className="md:w-2/3">
                <select
                  id="menucategory_id"
                  name="menucategory_id"
                  type="text"
                  className="bg-gray-200  border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  value={currentFoodDrink.menucategory_id}
                  onChange={handleInputChange}
                >
                  {menuCategory?.length > 0 &&
                    menuCategory.map((item, index) => (
                      <option
                        value={item.id}
                        key={index}
                      >
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                  Price $
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="price"
                  name="price"
                  type="text"
                  value={currentFoodDrink.price}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </form>

          <div className="md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3 grid grid-cols-2 gap-40">
              <button
                className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                onClick={deleteFoodDrink}
              >
                Delete
              </button>

              <button
                className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={updateFoodDrink}
              >
                Update
              </button>
            </div>
          </div>
        </>
      ) : (
        <div>
          <br />
          <p>Please click on a FoodDrink...</p>
        </div>
      )}
    </div>
  );
};

export default EditFoodDrink;
